import { inject, Injectable } from '@angular/core'
import { HttpService, LoggerService, ServiceType } from '@danangelus/ngx-app-core'
import { BulletinReadership } from '../../models/notifications/bulletin.model';

const log: LoggerService = LoggerService.get('NotificationService')

/**
 * Service to communicate with the notification-services on the back-end
 *
 * @author Dan Bennett
 */
@Injectable({
    providedIn: 'root'
})
export class NotificationService {

    private http: HttpService = inject(HttpService)

    async getBulletins(): Promise<any[]> {
        try {
            return this.http.get(ServiceType.NOTIFICATION, 'get-bulletins', null, null, false, true)
        } catch (err: any) {
            log.error(`There was an error attempting to retrieve bulletins! ${err}`)
        }
        return []
    }

    async saveBulletinReadStatus(id: string, bulletinReadership: BulletinReadership): Promise<any> {
        try {
            return this.http.post(ServiceType.NOTIFICATION, 'save-read-status', bulletinReadership, { id: id}, null, false, true)
        } catch (err: any) {
            log.error(`There was an error attempting to save a bulletin! ${err}`)
        }
        return []
    }
}
